<main class="login">
  <div class="login__container">
    <div class="page-success">
        <h2>✓</h2>
        <h3>Your data is submitted</h3>
        <div class="buttons"><a class="button button--secondary button--outline" (click)="ok()">OK</a></div>
    </div>
  </div>
</main>
